import type { IMenuProps, IOmit } from '@sixui/ui';
import {
  faCopy,
  faPaperPlane,
  faPen,
  faTrashCan,
} from '@fortawesome/pro-light-svg-icons';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Menu, MenuItem } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';

export type IArticleListItemMenuProps = IContainerProps &
  IOmit<IMenuProps, 'trigger' | 'children'> & {
    appId: string;
    articleId: string;
    processing?: boolean;
    handlePublish?: () => void;
    handleUnpublish?: () => void;
    handleDelete?: () => void;
    handleCopyShareUrl?: () => void;
  };

export const ArticleListItemMenu: React.FC<IArticleListItemMenuProps> = (
  props,
) => {
  const {
    sx,
    appId,
    articleId,
    processing,
    handlePublish,
    handleUnpublish,
    handleDelete,
    handleCopyShareUrl,
    ...other
  } = props;
  const { t } = useTranslation();

  return (
    <Menu
      trigger={({ getProps }) => (
        <IconButton
          icon={<FontAwesomeIcon icon={faEllipsisVertical} />}
          loading={processing}
          {...getProps()}
        />
      )}
      placement="bottom-end"
      sx={sx}
      {...other}
    >
      <MenuItem
        label={t('common.edit')}
        leadingIcon={<FontAwesomeIcon icon={faPen} />}
        href={`/apps/${appId}/articles/${articleId}/update`}
      />
      {handlePublish && (
        <MenuItem
          label={t('ArticleListItemMenu.publish')}
          leadingIcon={<FontAwesomeIcon icon={faPaperPlane} />}
          onClick={handlePublish}
        />
      )}
      {handleUnpublish && (
        <MenuItem
          label={t('ArticleListItemMenu.unpublish')}
          leadingIcon={<FontAwesomeIcon icon={faPaperPlane} />}
          onClick={handleUnpublish}
        />
      )}
      {handleCopyShareUrl && (
        <MenuItem
          label={t('ArticleListItemMenu.copyLink')}
          leadingIcon={<FontAwesomeIcon icon={faCopy} />}
          onClick={handleCopyShareUrl}
        />
      )}
      {handleDelete && (
        <MenuItem
          label={t('common.delete')}
          leadingIcon={<FontAwesomeIcon icon={faTrashCan} />}
          onClick={handleDelete}
          variant="danger"
        />
      )}
    </Menu>
  );
};
